import { defaultCountryIso2, supportedLocales } from '../../data/locale';

export const shouldRenderChangeLocaleBanner = (props) => {
  const {
    pathname,
    userSelectedLocale,
    localeInUrl,
    // IP locale from cloudflare cookies/headers on the serverside
    // Not set correctly on local development machine!
    userCountryCodeByIp,
    source,
  } = props;

  // We want to always hide the banner on the root page (as that is
  // the country selector homepage only now that US traffic is served
  // under /us)
  if (pathname === '/') {
    return false;
  }

  // We always want to show when somebody uses the footer links to change
  // to a different locale
  if (source === 'footer') {
    return true;
  }

  if (supportedLocales.map((l) => `/${l.slug}`).includes(pathname)) {
    if (userSelectedLocale) {
      // The user has selected a locale which is different to the
      // locale in the url
      if (localeInUrl && userSelectedLocale !== localeInUrl) {
        return true;
      }
    } else {
      // The user has not selected a locale.
      // However, if the locale suggested by their IP matches
      // the locale in the URL, assume they're on the
      // 'correct' locale
      if (localeInUrl && userCountryCodeByIp === localeInUrl) {
        return false;
      }

      // Here, the user has not selected a locale and the locale
      // in the URL is either missing or different to that from
      // their IP
      if (localeInUrl) {
        // If there is a locale in the URL, check their IP against that
        if (userCountryCodeByIp !== localeInUrl) {
          return true;
        }
      } else if (userCountryCodeByIp !== defaultCountryIso2) {
        // Else, if there isn't a locale in the URL, check their IP
        // against our default locale
        return true;
      }
    }
  }

  return false;
};
